import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss', './loader.component.rtl.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class LoaderComponent  {


 

}
